import { MIVPage } from "../../shared/pages";
import "./home.css";

export class HomePage extends MIVPage {

    constructor() {
        super("page_home", "home", "nav_home");
    }

    OpenAsync(): Promise<void> {
        // rien
        return Promise.resolve();
    }
    Close(): void {
        // rien
    }

    protected ResolvePathAndNavigateAsync(path: string, samePathAsCurrent: boolean): Promise<void> {
        return Promise.resolve();
    }
}